import Vue from 'vue'
import Router from 'vue-router'
import Onboarding from '../views/Onboarding.vue'
import OnAir from '../views/OnAir.vue'
import Analytics from '../views/Analytics.vue'
import AnalyticsSingle from '../views/AnalyticsSingle.vue'
import Settings from '../views/Settings.vue'
import History from '../views/History.vue'
import ScriptGenerator from '../views/ScriptGenerator.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'OnAir',
      component: OnAir
    },
    {
      path: '/onboarding',
      name: 'Onboarding',
      component: Onboarding
    },
    {
      path: '/on-air',
      name: 'OnAir',
      component: OnAir
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: Analytics
    },
    {
      path: '/analytics-single',
      name: 'AnalyticsSingle',
      component: AnalyticsSingle
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/history',
      name: 'History',
      component: History
    },
    {
      path: '/script-generator',
      name: 'ScriptGenerator',
      component: ScriptGenerator
    }
  ]
})
